import { computed, Ref } from '@vue/composition-api';
import useMainLayout from '@/composables/useMainLayout';
import VideoListLayout from '@/data/layout/VideoListLayout';
import { LayoutType } from '@/data/layout/MainLayoutInfo';

export default function useVideoListLayout(
  usePagination: boolean, rowCount?: Ref<number|undefined>, baseElem?: Ref<HTMLDivElement|null>) {
  
  const { layoutType, fullWidth } = useMainLayout();

  const videoListLayout = computed(() => {

    return new VideoListLayout(usePagination, layoutType.value, fullWidth.value,
      rowCount ? rowCount.value : undefined, baseElem?.value?.parentElement?.clientWidth);
  });

  let oldVideoListLayout = videoListLayout.value;
  let oldParentWidth = baseElem?.value?.parentElement?.clientWidth;
  let oldLayoutType = oldVideoListLayout.layoutType;
  let lastFullWidth = fullWidth.value;
  let oldRowCount = rowCount?.value;

  const getVideoListLayout = (parentWidth?: number) => {

    if(!parentWidth) parentWidth = baseElem?.value?.clientWidth;

    const fullWidthChanged = fullWidth.value !== lastFullWidth && layoutType.value === LayoutType.SMALL;
    const rowCountChanged = oldRowCount != rowCount?.value;

    if(parentWidth && (oldParentWidth != parentWidth || layoutType.value !== oldLayoutType || fullWidthChanged || rowCountChanged) ) {

      lastFullWidth = fullWidth.value;
      oldRowCount = rowCount?.value;

      oldParentWidth = parentWidth;
      oldLayoutType = layoutType.value;

      oldVideoListLayout = new VideoListLayout(usePagination, layoutType.value, fullWidth.value,
        rowCount ? rowCount.value : undefined, Math.floor(parentWidth));
    }
    return oldVideoListLayout;
  };

  return {
    videoListLayout,
    getVideoListLayout
  }
}

